var React = require('react');

function Ctftime (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#e3000b","d":"M0 80h283V0H0l33 40z","key":0}),React.createElement("path",{"fill":"#fff","d":"M62 58h18v-6H69V28h11v-7H62zm24-30h6v30h7V28h5v-7H86zm24 30h8V43h9v-6h-9v-9h11v-7h-19zm73-33h5v33h5V25h5v-4h-15zm20-4h4v37h-4zm21 14l-5-14h-4v37h4V32l5 13 5-13v26h5V21h-5zm21 19V42h7v-5h-7V25h12l1-4h-18v37h18l-1-4zM136 21v37h39V21zm34 32h-29V26h29v27m-16-14l-6 6 4 4 9-9-16-16h-7z","key":1})]);
}

Ctftime.defaultProps = {"viewBox":"0 0 283 80"};

module.exports = Ctftime;

Ctftime.default = Ctftime;
